import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router";

import {
  inventoryActions,
  shopifyActions,
  storeActions,
  systemActions,
} from "../../redux/actions";
import {
  EMPTY_STRING,
  inventoryConstants,
  storeConstants,
  toastType,
} from "../../constants";
import { createCompanyDynamicUrl, customToast } from "../utility";
import { useWebPubSub } from "./useWebPubSub";
import { handlePubSubKeys } from "../../system";
import { success } from "../../redux/actions/actionsUtilities";
import ViewOrderNotification from "../components/ToastPrintLabel/ViewOrderNotification";

// this component enables us to use react-router useNavigation hook outside .jsx files
const AppController = (props) => {
  const navigate = useNavigate();
  const {
    currentStore,
    isInventoryImporting,
    auditCompleted,
    setCurrentStore,
    updateAuditData,
    getUserNotifications,
    resetShopifyStateToEmpty,
    activateImportInventorySpinner,
    activateDraggableNotification,
    deactivateDraggableNotification,
    isRedirect,
    pageToRedirect,
    pageRedireaction,
  } = props;

  useEffect(() => {
    if (isRedirect) {
      navigate(createCompanyDynamicUrl(pageToRedirect));
      pageRedireaction(EMPTY_STRING);
    } // eslint-disable-next-line
  }, [isRedirect]);
  // Hook: Refresh when backend sends REFRESH_DATA
  useWebPubSub(currentStore, (keys) => {
    handlePubSubKeys(keys, {
      onNewShopifyOrder: (key) => {
        getUserNotifications(currentStore?.id);
        customToast(
          <span className="d-flex flex-column gap-2">
            {key.message.message}
            {<ViewOrderNotification orderId={key.message.orderId} />}
          </span>,
          toastType.INFO,
          7000
        );
      },
      onCustomerSyncWithShopifyUpdate: (key) => {
        setCurrentStore(key.message.body.data);
        customToast(key.message.body.message, toastType.INFO, 7000);
      },
      onShopifyIntegrationDisable: (key) => {
        if (currentStore?.id === key.message.body.data.id) {
          setCurrentStore(key.message.body.data);
          resetShopifyStateToEmpty();
        }
        customToast(key.message.body.message, toastType.INFO, 7000);
      },
      onAuditInitialized: (key) => {
        if (currentStore?.id === key.message.body.data.store.id) {
          updateAuditData(key.message.body.data);
        }
        customToast(key.message.body.message, toastType.INFO, 7000);
      },
      onAuditCompleted: (key) => {
        if (currentStore?.id === key.message.body.data.id) {
          auditCompleted(key.message.body.data.id);
        }
        customToast(key.message.body.message, toastType.INFO, 7000);
      },
      onInventoryAdded: (key) => {
        const payload = key?.message?.body?.data;

        const eventJobId = payload?.jobId;
        const storeId = payload?.store?.id;

        if (
          !eventJobId ||
          !isInventoryImporting?.jobId ||
          String(eventJobId) !== String(isInventoryImporting.jobId)
        ) {
          return;
        }

        if (
          currentStore?.id &&
          storeId &&
          String(currentStore.id) !== String(storeId)
        ) {
          return;
        }

        activateImportInventorySpinner({
          isVisible: false,
          message: "",
          jobId: null,
        });
      },
      onToastMessage: (key) => {
        const message = key?.message?.body?.message;
        const payload = key?.message?.body?.data;
        if (message) {
          customToast(message, payload.messageType ?? toastType.INFO, 7000);
        }
      },
      onActivateSpinner: (key) => {
        const message = key.message.body.message;
        const data = key.message.body.data;
        const spinnerType = data?.spinnerType;
        activateDraggableNotification({
          spinnerType,
          message,
        });
      },
      onDeactivateSpinner: (key) => {
        const currentStore = key?.message?.body?.data?.currentStore;
        const message = key.message.body.message;
        const data = key.message.body.data;
        const spinnerType = data?.spinnerType;
        deactivateDraggableNotification({
          message,
          spinnerType,
        });

        const shouldRefreshCurrentStore =
          data.shouldRefreshStoreOnDeactivatingSpinner;
        if (shouldRefreshCurrentStore) {
          setCurrentStore(currentStore);
        }
      },
    });
  });
  return <> </>;
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  isRedirect: state.system.isRedirect,
  pageToRedirect: state.system.pageToRedirect,
  currentStore: state.store.currentStore,
  isInventoryImporting: state.inventory.isInventoryImporting,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  pageRedireaction: (value, path) =>
    dispatch(systemActions.pageRedireaction(value, path)),
  getUserNotifications: (storeId) =>
    dispatch(storeActions.getUserNotifications(storeId)),
  setCurrentStore: (data) =>
    dispatch(success(data, storeConstants.SET_CURRENT_STORE)),
  updateAuditData: (data) =>
    dispatch(success(data, inventoryConstants.UPDATE_STOCK_AUDIT)),
  auditCompleted: (data) =>
    dispatch(success(data, storeConstants.UPDATE_AUDIT_SESSION_COMPLETE_FALSE)),
  resetShopifyStateToEmpty: () =>
    dispatch(shopifyActions.resetShopifyStateToEmpty()),
  activateImportInventorySpinner: (data) =>
    dispatch(inventoryActions.activateImportInventorySpinner(data)),
  activateDraggableNotification: (data) =>
    dispatch(systemActions.activateDraggableNotification(data)),
  deactivateDraggableNotification: (data) =>
    dispatch(systemActions.deactivateDraggableNotification(data)),
});

//-------Export PageRedireaction Component
export default connect(mapStateToProps, mapDispatchToProps)(AppController);
